import { render, staticRenderFns } from "./SituacaoPill.vue?vue&type=template&id=dfef978c&scoped=true"
import script from "./SituacaoPill.vue?vue&type=script&lang=js"
export * from "./SituacaoPill.vue?vue&type=script&lang=js"
import style0 from "./SituacaoPill.vue?vue&type=style&index=0&id=dfef978c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfef978c",
  null
  
)

export default component.exports